import { LocationStrategy } from "@angular/common";
import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from "@angular/core";
import { MatTabGroup } from "@angular/material/tabs";
import { AppService } from "@api";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { AsignacionEvaluacion } from "@modelo/proceso/asignacionevaluacion.model";
import { PeriodoEvaluacion } from "@modelo/proceso/periodoevaluacion.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { AsignacionEvaluacionAlmunosMateriasComponent } from "./seccion/asignacionevaluacionalumno_materia.component";
import { AsignacionEvaluacionAlumnosForms } from "./asignacionevaluacionalumnomateriaform.component";
import { Evaluacion } from "@modelo/global/Evaluacion.model";
import { EvaluacionPendientePrevisualizarAlumnoComponent } from "@contenido/AppContent/evaluacionpendiente/alumno/previsualizar/previsualizar_alumno.component";
import { EvaluacionAlumno } from "@modelo/global/EvaluacionAlumno.model";


@Component({
    selector: 'asignacionevaluacionalumnos',
    templateUrl: './asignacionevaluacionalumno.component.html',
})

export class AsignacionEvaluacionAlmunosComponent implements AfterViewInit, OnInit{
    entidad: PeriodoEvaluacion;
    @ViewChild('tab') private tab!: MatTabGroup;
    @ViewChild('general') private asignaciongeneralComponent!: AsignacionEvaluacionAlmunosMateriasComponent;
    @Input() accion!: {accion: string, entidad:any};
    @Input() id!: number;
    @Input() identificador!: number;
    @Input() cicloid!: number;
    @Output() output = new EventEmitter();
    cambio: boolean = false;
    visualizar:boolean = false;
    public errorActivo!: boolean;

    consulta!: boolean;

    @ViewChild("asignacionevaluacionalumnosmaterias", {read: ViewContainerRef}) asignacionevaluacionalumnosmaterias!: ViewContainerRef;

    @ViewChild("containerEvaluacion", {read: ViewContainerRef}) containerEvaluacion!: ViewContainerRef;

    constructor(private appService: AppService,private location: LocationStrategy, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver){
        this.entidad = new PeriodoEvaluacion();
        history.pushState(null, "", window.location.href);
        this.location.onPopState(() => {
            this.Salir();
        });
    }
    ngOnInit(){
        this.SetPeriodoEvaluacion();
    }

    ngAfterViewInit(){
        if(this.identificador == 2){
            this.visualizar = true;
        }
    }

    formulario(){
        if(this.asignaciongeneralComponent.valoraccion){
            this.cargarContenedorFormulario({accion:this.asignaciongeneralComponent.valoraccion.accion,entidad:this.asignaciongeneralComponent.valoraccion.entidad, periodoevaluacionportipoevaluacionid:this.asignaciongeneralComponent.valoraccion.periodoevaluacionportipoevaluacionid, accionid:this.asignaciongeneralComponent.valoraccion.accionid});
        }
    }

    SetPeriodoEvaluacion(){
        this.appService.Post("planeacion/periodoevaluacion/buscar", {"periodoevaluacionid":this.id}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.entidad = new PeriodoEvaluacion(res.data[0]);
            }
        })
    }

    cargarContenedorFormulario(data: {accion: string, entidad: any, periodoevaluacionportipoevaluacionid:number, accionid:number}) {
        this.consulta = true;
        this.asignacionevaluacionalumnosmaterias.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AsignacionEvaluacionAlumnosForms);
        var ref: ComponentRef<any> = this.asignacionevaluacionalumnosmaterias.createComponent(factory);
        ref.instance.accion = {accion: data.accion, entidad: data.entidad};
        ref.instance.id = this.id;
        ref.instance.entidad = new PeriodoEvaluacion(this.entidad);
        ref.instance.identificador = data.accionid;
        ref.instance.tipoevaluacionid = this.accion.entidad.tipoevaluacionid;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if(cambio){
                this.asignaciongeneralComponent.SetNivelYGrado();
            }
        });
    }

    Guardar(){
    this.asignaciongeneralComponent.Guardar();
    }

    Salir(){
        this.output.next(this.cambio);
    }

    cargarprevisualizacion(e:any){
        let entidadtemporal = new EvaluacionAlumno(e);
        entidadtemporal.periodoevaluacionid = this.entidad.periodoevaluacionid;
        entidadtemporal.puesto = "Rector";
        entidadtemporal.departamento = "Rectoria";
        entidadtemporal.nombre = "Previsualizar";
        entidadtemporal.periodoevaluacion = this.entidad.descripcion;
        this.consulta = true;
        this.containerEvaluacion.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(EvaluacionPendientePrevisualizarAlumnoComponent);
        var ref: ComponentRef<any> = this.containerEvaluacion.createComponent(factory);
        ref.instance.entidad = entidadtemporal;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if (cambio) {

            }
        });
    }
}
